import { TileLayer, LayersControl } from 'react-leaflet';
const { BaseLayer } = LayersControl;

const LayersControlComponent = () => (
    <LayersControl position="topright">
        <BaseLayer checked name="Google Satellite">
            <TileLayer
                attribution="Built with ❤️"
                url="https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
            />
        </BaseLayer>
        <BaseLayer name="OpenStreetMap">
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
        </BaseLayer>
        <BaseLayer name="Esri Satellite">
            <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="&copy; Esri"
            />
        </BaseLayer>
    </LayersControl>
);

export default LayersControlComponent;